import React from 'react'
import { NavLink, Link } from 'react-router-dom'
import UserMenu from './UserMenu';

const NAV_ITEMS = [
    {
        key: "overview",
        label: "Overview",
        path: "/overview",
        icon: "/svg/overview.svg"
    },
    {
        key: "agent-library",
        label: "Agent Library",
        path: "/agents",
        icon: "/svg/agentIcon.svg",
        renderExtra: (props) =>
            props.agents?.length > 0 && !props.isGuest? (
                <span className="total__agents">{props.agents.length}</span>
            ) : null,
    },
    {
        key: "execution-history",
        label: "Execution History",
        path: "/history",
        icon: "/svg/history.svg",
        renderExtra: () => (
            <span className="expand__icon">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 10.5L9 7L5 3.5" stroke="#5F636A" strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </span>
        ),
    },
];

export default function Sidebar({ auth, isAdminOrSubadmin, onOpenFeedback, agents, projects, open, onClose, collapsed, onToggleCollapse }) {
    // Overview is a project score dashboard, which a guest has no project for.
    const isGuest = auth?.user?.role === "guest";
    const navItems = isGuest
        ? NAV_ITEMS.filter((item) => item.key !== "overview")
        : NAV_ITEMS;

    return (
        <React.Fragment>
            <aside className={`app-sidebar ${open ? "app-sidebar--open" : ""}${collapsed ? "app-sidebar--collapsed" : ""}`} >
                <div className="wrapper__app__side__left">
                    <div className="wrapper__side__navigation">
                        <div className="sidebar__top">
                            <Link onClick={onClose} to="/" className="sidebar__brand fb__14 pos__rel">
                                <img
                                    src={collapsed ? "/svg/saffronos-short.svg" : "/saffronos.png"}
                                    alt="SaffronOS Logo"
                                    className={`logo-img ${collapsed ? "logo-img--short" : ""}`}
                                />
                                <b className="betaTag">Beta</b>
                            </Link>

                            <button
                                type="button"
                                className="sidebar__toggle"
                                onClick={onToggleCollapse}
                                aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
                                aria-expanded={!collapsed}
                                title={collapsed ? "Expand sidebar" : "Collapse sidebar"}
                            >
                                <img src="/svg/collapse-sidebar.svg" alt={collapsed ? "Expand sidebar" : "Collapse sidebar"} />
                            </button>
                        </div>

                        <div className="workSpace">Workspace</div>

                        <nav className="sidebar-nav">
                            <ul className="sidebar__nav__ul">
                                {navItems.map((item) => (
                                    <li key={item.key} className="wrapper__sidenav__item">
                                        <NavLink
                                            to={item.path}
                                            onClick={onClose}
                                            className="sidebar-nav-item">
                                            <img src={item.icon} alt={item.label} className="logo-img" />
                                            <span className="nav__title">{item.label}</span>
                                            {item.renderExtra?.({ agents, projects, isGuest })}
                                        </NavLink>
                                    </li>
                                ))}
                            </ul>
                        </nav>
                    </div>

                    <div className="sidebar-footer">
                        <UserMenu
                            auth={auth}
                            isAdminOrSubadmin={isAdminOrSubadmin}
                            onOpenFeedback={onOpenFeedback}
                            projects={projects}
                            onClose={onClose}
                        />
                    </div>
                </div>
            </aside>
        </React.Fragment>
    )
}